import { Typography, List, ListItem, Box, Paper } from '@mui/material';
import type { Asset } from 'types/asset.types';
import { SVG } from 'components/Asset/SVG';
import { TextButton } from 'components/Buttons/TextButton';

import { mapVehiclesAssets } from 'utils/helpers/mapAssetImage';
import { ThemePalette } from 'mui.theme';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface Props {
  assets: Asset[];
  selectedAssetIds: string[];
  enableDarkTheme: boolean;
  handleCheckBoxSelected: any;
}

const FooterDisplay = ({
  assets,
  selectedAssetIds,
  enableDarkTheme,
  handleCheckBoxSelected,
}: Props) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const { t } = useTranslation();
  const selectedAssets = assets.filter((asset: Asset) =>
    selectedAssetIds.includes(asset.assetId)
  );
  return (
    <Box
      sx={{
        backgroundColor: enableDarkTheme
          ? palette.pageBackground
          : palette.pageBackground,
        color: palette.textPrimary,
        paddingBottom: '0',
      }}
    >
      <List
        style={{
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <ListItem>{t('selected_assets')}</ListItem>
        {selectedAssets.map((asset) => {
          return (
            <ListItem key={asset.assetId}>
              <Paper
                elevation={3}
                sx={{
                  color: palette.textPrimary,
                  backgroundColor: 'inherit',
                  height: '60px',
                  width: '180px',
                  border: `1px solid ${palette.borderGrey}`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <TextButton
                  sx={{
                    minHeight: '19px',
                    minWidth: '19px',
                  }}
                  onClick={() => {
                    handleCheckBoxSelected(asset.assetId);
                  }}
                >
                  <Typography>X</Typography>
                </TextButton>

                <SVG
                  name={mapVehiclesAssets(asset.assetType)}
                  style={{
                    fill: '#E2C171',
                    paddingLeft: '20px',
                    width: '55px',
                  }}
                />
                <Typography
                  sx={{
                    paddingLeft: '20px',
                  }}
                >
                  {asset.bumperNumber}
                </Typography>
              </Paper>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default FooterDisplay;
